import {
  AccountApproverEntry,
  AutoApprovalConfigResponse,
  ItemApiEditApproversRequest,
  ItemApiGetAutoApprovalConfigurationRequest,
  ItemApiListAccountApproversRequest,
  ItemApiSaveAutoApprovalConfigurationRequest,
} from '@ariksa/jit/api';
import { UserServiceListRequest, UserServiceListResponse } from 'api/auth/api.pb';
import { QueryAction } from 'services/types';
import { QueryState } from 'services/utils/QueryState';

import { createSlice } from 'utils/@reduxjs/toolkit';

import { ContainerState } from './types';

export const initialState: ContainerState = {
  approvers: QueryState.init([] as AccountApproverEntry[]),
  autoApprovalConfiguration: QueryState.init({} as AutoApprovalConfigResponse),
  jitUsers: QueryState.init({} as UserServiceListResponse),
  jitAction: QueryState.init({}),
};

const jitSlice = createSlice({
  // Shared state for all JIT routes.
  name: 'jit',
  initialState,
  reducers: {
    getApprovers(
      state,
      action: QueryAction<
        AccountApproverEntry[],
        ItemApiListAccountApproversRequest
      >,
    ) {
      state.approvers = QueryState.next(state.approvers, action);
    },
    getJitUsers(
      state,
      action: QueryAction<UserServiceListResponse, UserServiceListRequest>,
    ) {
      state.jitUsers = QueryState.next(state.jitUsers, action);
    },
    editApprovers(
      state,
      action: QueryAction<any, ItemApiEditApproversRequest>,
    ) {
      state.jitAction = QueryState.next(state.jitAction, action);
    },
    getAutoApprovalConfiguration(
      state,
      action: QueryAction<
        AutoApprovalConfigResponse,
        ItemApiGetAutoApprovalConfigurationRequest
      >,
    ) {
      state.autoApprovalConfiguration = QueryState.next(
        state.autoApprovalConfiguration,
        action,
      );
    },
    saveAutoApprovalConfiguration(
      state,
      action: QueryAction<
        AutoApprovalConfigResponse,
        ItemApiSaveAutoApprovalConfigurationRequest
      >,
    ) {
      state.jitAction = QueryState.next(state.jitAction, action);
    },
  },
});

export const { actions, reducer, name: sliceKey } = jitSlice;
